import React from 'react';
import { Shield, Target, Award } from 'lucide-react';
export function KidsConfidence() {
  return <section className="py-24 bg-off-white" data-id="element-1901">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1902">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1903">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1904">
            Confidence, Focus & Discipline
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-1905">
            These are the words parents use when they tell us why they brought
            their kids to Storm — and what they noticed within a few months of
            training.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-1906">
          {[{
          icon: Shield,
          title: 'Confidence',
          desc: 'Kids stand taller, speak up more, and believe they can take on hard things. Belt promotions give them visible proof of progress.'
        }, {
          icon: Target,
          title: 'Focus',
          desc: 'Drills require sustained attention. That focus carries over to homework, listening at home, and handling distractions at school.'
        }, {
          icon: Award,
          title: 'Discipline',
          desc: "Showing up, putting in effort, and following the coach's instructions — these become habits that go far beyond the mat."
        }].map((item, i) => <div key={i} className="bg-paper border border-subtle-gray rounded-2xl p-8 text-center flex flex-col items-center gap-4" data-id="element-1907">
              <div className="w-14 h-14 rounded-2xl bg-storm-red/10 flex items-center justify-center text-storm-red" data-id="element-1908">
                <item.icon className="w-7 h-7" data-id="element-1909" />
              </div>
              <h3 className="text-xl text-ink" data-id="element-1910">{item.title}</h3>
              <p className="text-gray-warm leading-relaxed" data-id="element-1911">{item.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}